// ---------------------------------------------------------------------------
// The deadline every door is being knocked against, and the daily pace it
// implies. Kept pure so it can be unit tested.
// ---------------------------------------------------------------------------

/** Election day, as a local calendar date. Month is 1-based. */
export const ELECTION_DAY = { year: 2026, month: 11, day: 3 } as const;

/**
 * Knocking days left before election day, counting today and not counting
 * election day itself -- "knocked by November 3rd" means done by the night of
 * the 2nd. Calendar days, not 24-hour spans, so the answer does not change at
 * noon or skip across a daylight-saving boundary.
 */
export function daysUntilElection(now: Date = new Date()): number {
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const election = Date.UTC(ELECTION_DAY.year, ELECTION_DAY.month - 1, ELECTION_DAY.day);
  return Math.max(0, Math.round((election - today) / 86_400_000));
}

/** Homes a day needed to finish in time, rounded up. Null once there are no days left. */
export function homesPerDay(remaining: number, daysLeft: number): number | null {
  if (daysLeft <= 0) return null;
  return Math.ceil(Math.max(0, remaining) / daysLeft);
}
